import React from 'react';

import { FilledInputProps, InputProps, TextField as MuiTextField, OutlinedInputProps } from '@mui/material';

interface CustomTextFieldProps {
  error?: boolean | undefined;
  value: string | undefined | null;
  onChange: React.ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement> | undefined;
  className?: string;
  label?: string;
  id?: string;
  name?: string;
  type?: string;
  disabled?: boolean;
  variant?: 'standard' | 'filled' | 'outlined';
  inputMode?: 'numeric' | 'text' | 'email' | 'search' | 'tel' | 'url' | 'none' | 'decimal' | undefined;
  placeholder?: string;
  errorMessage?: string;
  inputProps?: Partial<FilledInputProps> | Partial<OutlinedInputProps> | Partial<InputProps>;
}

const TextField = ({
  error,
  value,
  onChange,
  className,
  label,
  id,
  name,
  type = 'text',
  disabled,
  variant = 'standard',
  inputMode,
  placeholder,
  errorMessage,
  inputProps
}: CustomTextFieldProps) => {
  if (type === 'number') {
    inputMode = 'numeric';
    type = 'text';
  }

  return (
    <MuiTextField
      error={error}
      value={value}
      onChange={onChange}
      type={type}
      label={label}
      id={id}
      name={name}
      disabled={disabled}
      className={className}
      variant={variant}
      inputMode={inputMode}
      placeholder={placeholder}
      role="textbox"
      helperText={error ? errorMessage : ''}
      InputProps={inputProps}
    />
  );
};

export default TextField;
